<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
        <template v-slot:activator="{ on }">
            <v-btn color="info" dark v-on="on">
                Show Prediction Summary
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="text-h5">Prediction Summary</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                  <strong>Last Successful Scoring </strong>{{friendlyLastPredictionText}}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="text-center">
                    <Plotly :data="chartData" :layout="chartLayout" :display-mode-bar="false"></Plotly>
                  </v-col>
                </v-row>

                <v-row class="text-h5">
                  <v-col cols="1">
                    <v-icon color="#6AC2E1">fa-dot-circle</v-icon>
                  </v-col>
                  <v-col cols="5">
                    {{highPercentage}}% <v-icon color="#6AC2E1">fa-check</v-icon>
                  </v-col>
                  <v-col cols="1">
                    <v-icon color="#D71F27">fa-dot-circle</v-icon>
                  </v-col>
                  <v-col cols="5">
                    {{100-highPercentage}}% <v-icon color="#D71F27">fa-user-edit</v-icon>
                  </v-col>
                </v-row>

                <v-row>
                    <v-col cols="1"/>
                    <v-col cols="5">
                      {{this.chartData[0].values[0]}} transactions above the confidence score.
                    </v-col>
                    <v-col cols="1"/>
                    <v-col cols="5">
                      {{this.chartData[0].values[1]}} transactions below the confidence score and need review.
                    </v-col>
                </v-row>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="blue white--text" @click="dialog=false">View All</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Prop, Inject, Watch,
} from 'vue-property-decorator';
import { TransactionClassificationRule, TransactionClassificationRuleResource }
  from '@/api/transactionclassification/';
import { Plotly } from 'vue-plotly';

@Component({
  components: {
    Plotly,
  },
})
export default class PredictionSummaryDialog extends Vue {
    @Prop({ default: [] })
    rules!:Array<TransactionClassificationRule>;

    @Prop({ default: null })
    lastPredictionTime!:Date;

    dialog:boolean = false;

    friendlyLastPredictionText:string = 'Never';

    series:number[] = [];

    highPercentage:number = 0;

    chartData:any[] = [{
      values: [123, 456],
      rotation: 90,
      hole: 0.75,
      type: 'pie',
      textinfo: 'none',
      showlegend: false,
      labels: ['High Confidence', 'Low Confidence'],
      marker: {
        colors: ['#6AC2E1', '#D71F27'],
      },
    }]

    chartLayout:any = {
      width: 350,
      height: 200,
      margin: {
        t: 0, b: 0, l: 0, r: 0,
      },
      annotations: [
        {
          font: {
            size: 24,
          },
          showarrow: false,
          text: '',
          x: 0.5,
          y: 0.6,
        },
        {
          font: {
            size: 18,
          },
          showarrow: false,
          text: 'Total',
          x: 0.5,
          y: 0.45,
        },
        {
          font: {
            size: 18,
          },
          showarrow: false,
          text: 'Transactions',
          x: 0.5,
          y: 0.29,
        },
      ],
    }

    @Watch('dialog')
    onDialogToggle() {
      if (this.dialog && this.lastPredictionTime) {
        this.friendlyLastPredictionText = this.lastPredictionTime.toLocaleString();

        let lowConfidence:number = 0;
        let highConfidence:number = 0;
        this.rules.forEach((rule) => {
          const confidence:number = PredictionSummaryDialog.getConfidenceForRule(rule);
          if (confidence > 0 && rule.lastQueryCount) {
            if (confidence < 0.85) {
              lowConfidence += rule.lastQueryCount;
            } else {
              highConfidence += rule.lastQueryCount;
            }
          }
        });

        this.chartData[0].values = [highConfidence, lowConfidence];
        this.chartLayout.annotations[0].text = (lowConfidence + highConfidence).toString();

        this.highPercentage = Math.round(highConfidence * (100 / (highConfidence + lowConfidence)));
      }
    }

    static getConfidenceForRule(rule:TransactionClassificationRule):number {
      let confidence:number = 0;

      if (rule.predictions) {
        rule.predictions.forEach((prediction) => {
          if (prediction.confidence > confidence) {
            confidence = prediction.confidence;
          }
        });
      }

      return confidence;
    }
}
</script>

<style lang="scss" scoped>
</style>
